"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var ReactDOM = require("react-dom");
var index_1 = require("../src/ontodia/index");
var common_1 = require("./common");
var N3Parser = require('rdf-parser-n3');
var RdfXmlParser = require('rdf-parser-rdfxml');
var JsonLdParser = require('rdf-parser-jsonld');
var EXAMPLE = "@prefix fts: <https://w3id.org/datafabric.cc/ontologies/fts#> .\n @prefix xsd: <http://www.w3.org/2001/XMLSchema#> .\n @prefix ex: <http://example.com/> .\n\n ex:LED-1 a fts:C4_Legal_Entity_Details ;\n    fts:p80_describes_company ex:LE-1 ;\n    fts:p81_includes_le_reg_entity ex:LE-1-NameEntity-1157847449121,\n                        ex:LE-1-Address-1157847449121,\n                        ex:LE-1-RegInfo-1157847449121 .\n ex:LE-1-NameEntity-1157847449121 a fts:C38_Name_Entity ;\n        fts:p82_refers_to_company ex:LE-1 ;\n        fts:p76_entered_on_registry_with ex:RND-1157847449121 ;\n        fts:p16_full_name \"\u041E\u0411\u0429\u0415\u0421\u0422\u0412\u041E \u0421 \u041E\u0413\u0420\u0410\u041D\u0418\u0427\u0415\u041D\u041D\u041E\u0419 \u041E\u0422\u0412\u0415\u0422\u0421\u0422\u0412\u0415\u041D\u041D\u041E\u0421\u0422\u042C\u042E \\\"\u0414\u0410\u0422\u0410\u0424\u0410\u0411\u0420\u0418\u041A\\\"\"@ru ;\n        fts:p17_short_name \"\u041E\u041E\u041E \\\"\u0414\u0410\u0422\u0410\u0424\u0410\u0411\u0420\u0418\u041A\\\"\"@ru .\n ex:LE-1-Address-1157847449121 a fts:C39_Address_Entity ;\n        fts:p82_refers_to_company ex:LE-1 ;\n        fts:p76_entered_on_registry_with ex:RND-1157847449121 ;\n        fts:p18_postcode \"193231\" ;\n        fts:p21_block \"\u041A\u041E\u0420\u041F\u0423\u0421 2\" ;\n        fts:p23_office_number \"\u041A\u0412\u0410\u0420\u0422\u0418\u0420\u0410 83\" ;\n        fts:p20_address_code \"780000000000684\" ;\n        fts:p22_building_number \"\u0414\u041E\u041C 11\" ;\n        fts:p98_located_at ex:Region-78 ;\n        fts:p98_located_at ex:Street-1 .\n ex:LE-1-RegInfo-1157847449121 a fts:C41_LE_Registration_Entity ;\n        fts:p82_refers_to_company ex:LE-1 ;\n        fts:p76_entered_on_registry_with ex:RND-1157847449121 ;\n        fts:p28_le_primary_state_registration_number \"1157847449121\" ;\n        fts:p29_psrn_assignment_date \"25-12-2015\"^^xsd:date .\n";
var DIAGRAM = "@prefix fts: <https://w3id.org/datafabric.cc/ontologies/fts#> .\n @prefix xsd: <http://www.w3.org/2001/XMLSchema#> .\n @prefix ex: <http://example.com/> .\n\n ex:LED-1 a fts:C4_Legal_Entity_Details ;\n    fts:p80_describes_company ex:LE-1 ;\n    fts:p81_includes_le_reg_entity ex:LE-1-NameEntity-1157847449121,\n                        ex:LE-1-Address-1157847449121,\n                        ex:LE-1-RegInfo-1157847449121 .";
function onWorkspaceMounted(workspace) {
    if (!workspace) {
        return;
    }
    var provider = new index_1.RDFDataProvider({
        data: [
            {
                content: EXAMPLE,
                type: 'text/turtle',
            }
        ],
        dataFetching: false,
        parsers: {
            'text/turtle': new N3Parser(),
            'application/rdf+xml': new RdfXmlParser(),
            'application/ld+json': new JsonLdParser(),
        },
    });
    var graphBuilder = new index_1.GraphBuilder(provider);
    var loadingGraph = graphBuilder.getGraphFromTurtleGraph(DIAGRAM);
    workspace.showWaitIndicatorWhile(loadingGraph);
    loadingGraph.then(function (_a) {
        var diagram = _a.diagram, preloadedElements = _a.preloadedElements;
        var model = workspace.getModel();
        return model.importLayout({
            diagram: diagram,
            preloadedElements: preloadedElements,
            dataProvider: provider,
        });
    }).then(function () {
        workspace.forceLayout();
        workspace.zoomToFit();
    });
}
var props = {
    ref: onWorkspaceMounted,
};
common_1.onPageLoad(function (container) { return ReactDOM.render(react_1.createElement(index_1.Workspace, props), container); });
